import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Contact API
export const submitContact = async (contactData) => {
  try {
    const response = await axios.post(`${API_URL}/contact/`, contactData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Creators API
export const getCreators = async () => {
  try {
    const response = await axios.get(`${API_URL}/creators/`);
    return response.data.creators;
  } catch (error) {
    console.error('Error fetching creators:', error);
    return [];
  }
};

// Web Series API
export const getWebSeries = async () => {
  try {
    const response = await axios.get(`${API_URL}/webseries/`);
    return response.data.series;
  } catch (error) {
    console.error('Error fetching web series:', error);
    return [];
  }
};

// YouTube Channels API
export const getYouTubeChannels = async () => {
  try {
    const response = await axios.get(`${API_URL}/youtube/channels`);
    return response.data.channels;
  } catch (error) {
    console.error('Error fetching YouTube channels:', error);
    return [];
  }
};

// Statistics API
export const getStatistics = async () => {
  try {
    const response = await axios.get(`${API_URL}/stats/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching statistics:', error);
    return null;
  }
};

// Instagram Feed API
export const getInstagramFeed = async (account) => {
  try {
    const response = await axios.get(`${API_URL}/instagram/feed?account=${account}`);
    return response.data.posts;
  } catch (error) {
    console.error('Error fetching Instagram feed:', error);
    return [];
  }
};
